/** Parse backend timestamps; treat missing timezone as UTC (app contract). */
export function parseAppUtcDate(iso: string | null | undefined): Date | null {
  const raw = String(iso ?? "").trim()
  if (!raw) return null
  let s = raw
  const hasTz = /[zZ]$/.test(s) || /[+-]\d{2}:\d{2}$/.test(s)
  if (!hasTz) {
    s = s.includes("T") ? `${s}Z` : `${s}T00:00:00Z`
  }
  const d = new Date(s)
  return Number.isFinite(d.getTime()) ? d : null
}

export function formatAppDateTime(
  iso: string | null | undefined,
  opts?: { withTimezoneLabel?: boolean },
): string {
  const d = parseAppUtcDate(iso)
  if (!d) return "—"
  const formatted = d.toLocaleString(undefined, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
  })
  if (opts?.withTimezoneLabel) {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
    return `${formatted} (${tz})`
  }
  return formatted
}

/** Prefer explicit UTC field from API, then legacy alias. */
export function pickUtcTimestamp(
  row: Record<string, unknown> | null | undefined,
  keys: string[],
): string | null {
  if (!row) return null
  for (const key of keys) {
    const v = row[key]
    if (typeof v === "string" && v.trim()) return v.trim()
  }
  return null
}
